import React, { useState } from 'react';
import { ExpandMore } from '@mui/icons-material';
import { useChatContext } from '../context/ChatContext';

const ExpertsPopup: React.FC = () => {
  const { uiState, appState, setSelectedExpert } = useChatContext();
  const [open, setOpen] = useState(false);
  
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setOpen((prev) => !prev);
  };
  
  const handleClose = () => {
    setOpen(false);
    // Remove focus from the expert button to prevent the black border
    const expertButton = document.querySelector('.experts-dropdown-btn') as HTMLButtonElement;
    if (expertButton) {
      expertButton.blur();
    }
  };

  const handleExpertSelect = (expert: any) => {
    setSelectedExpert(expert);
    handleClose();
  };

  // Close dropdown if clicking outside
  React.useEffect(() => {
    if (!open) return;
    const handleDocumentClick = (e: MouseEvent) => {
      const dropdown = document.getElementById('custom-experts-dropdown');
      const expertButton = document.querySelector('.experts-dropdown-btn');
      
      // Don't close if clicking on the dropdown itself or the expert button
      if (dropdown && !dropdown.contains(e.target as Node) && 
          expertButton && !expertButton.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && open) {
        setOpen(false);
        // Remove focus from the expert button to prevent the black border
        const expertButton = document.querySelector('.experts-dropdown-btn') as HTMLButtonElement;
        if (expertButton) {
          expertButton.blur();
        }
      }
    };
    
    document.addEventListener('mousedown', handleDocumentClick);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('mousedown', handleDocumentClick);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [open]);

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <button
        className="experts-dropdown-btn"
        onClick={handleClick}
        type="button"
      >
        <span>{uiState.selectedExpert?.name || uiState.selectedExpert?.archetype || 'Choose Expert'}</span>
        <ExpandMore />
      </button>
      {open && (
        <div
          id="custom-experts-dropdown"
          style={{
            position: 'absolute',
            bottom: '100%',
            right: 0,
            minWidth: 320,
            maxHeight: '400px',
            overflowY: 'auto',
            background: '#fff',
            border: '1px solid #ddd',
            borderRadius: 8,
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            zIndex: 3000,
            marginBottom: 4,
            padding: 0
          }}
        >
          {appState.filteredExperts?.length > 0 ? appState.filteredExperts.map(expert => {
            const expertIdentifier = expert.name || expert.archetype || expert.id || expert.ID;
            const selectedExpertIdentifier = uiState.selectedExpert?.name || uiState.selectedExpert?.archetype || uiState.selectedExpert?.id || uiState.selectedExpert?.ID;
            const expertName = expert.name || expert.archetype || expert.ARCHETYPE || '(Unnamed Expert)';
            const expertDesc = expert.description || expert.DESCRIPTION || '';
            const fullTooltip = `${expertName}\n\n${expertDesc}`;
            return (
              <div
                key={expertIdentifier}
                className={`expert-card${selectedExpertIdentifier === expertIdentifier ? ' selected' : ''}`}
                style={{ cursor: 'pointer' }}
                title={fullTooltip}
                onClick={(e) => { 
                  e.stopPropagation();
                  handleExpertSelect(expert); 
                }}
              >
                <div className="expert-details">
                  <div className="expert-name">{expertName}</div>
                  <div className="expert-description">{expertDesc}</div>
                </div>
              </div>
            );
          }) : (
            <div style={{ padding: '16px', textAlign: 'center', color: '#888' }}>
              No experts available
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ExpertsPopup; 